import { FEATURE_CONTENT } from '@/features/marketing/content/features';
import { findFeatureNavItem } from '@/features/marketing/nav';
import { registerSiteContent } from '@/features/siteContent/runtime';

/**
 * What a search result shows for each marketing page: the tab title and the
 * meta description.
 *
 * Every page used to share index.html's, so to a search engine the whole site
 * was one page said over and over. The home page keeps index.html's (it is the
 * brand's own line); a policy page names itself from the policy it loaded.
 */
export interface MarketingMeta {
  title: string;
  description: string;
}

export const PAGES: Record<string, MarketingMeta> = {
  '/why-shoplaunch': {
    title: 'Why NeonCarts',
    description:
      'The commerce platform that works the way India sells - your own online store, WhatsApp selling, UPI and COD payments and GST invoices in one place.',
  },
  '/pricing': {
    title: 'Pricing',
    description:
      'NeonCarts plans and prices, monthly or yearly. Compare what each plan includes - your online store, payments, WhatsApp selling, AI tools and more.',
  },
  '/enterprise': {
    title: 'Enterprise',
    description:
      'Commerce at scale, without the enterprise drag - the same fast platform first-time sellers use, with limits removed, team roles and permissions, your own domain and hands-on setup.',
  },
  '/talk-to-sales': {
    title: 'Talk to sales',
    description:
      'Tell us about your business and we will help you find the right NeonCarts setup - the plan, hands-on help getting started and anything custom you need.',
  },
  '/help': {
    title: 'Video help centre',
    description:
      'Short, simple how-to videos for NeonCarts: set up your online shop, add products, take payments, ship orders and sell on WhatsApp - step by step.',
  },
  '/become-a-partner': {
    title: 'Become a partner',
    description:
      'Get paid for the shops you bring online. Hand a business your code, they get money off their first NeonCarts plan, and you earn on what they pay.',
  },
  '/legal': {
    title: 'Terms & policies',
    description: 'The terms, privacy policy and other policies that apply to using NeonCarts.',
  },
  '/deals': {
    title: "Today's Deals",
    description:
      'Live offers for new merchants starting a shop on NeonCarts. Pick a deal and apply it when you sign up.',
  },
};

const FEATURE_PREFIX = '/features/';

/** The title and description for a marketing path, or null to keep the document's own. */
export function marketingMeta(pathname: string): MarketingMeta | null {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (path.startsWith(FEATURE_PREFIX)) {
    const slug = path.slice(FEATURE_PREFIX.length);
    const navItem = findFeatureNavItem(slug);
    const content = FEATURE_CONTENT[slug];
    if (!navItem || !content) return null;
    return { title: navItem.label, description: content.lede };
  }
  return PAGES[path] ?? null;
}

registerSiteContent('seo', { PAGES });
